<template>
    <div class="card card--bordered card--user">
        <div class="card--user__inner">
            <div class="card--user__image"></div>

            <div>
                <h6 class="heading6">Courtney Ritter</h6>
                <p>Account Manager</p>
            </div>
        </div>

        <div class="card--user__controls">
            <a v-if="false" href="https://meetings.hubspot.com/pali-sabbineni" target="_blank" class="link-schedule" @click="scheduleMeeting">Schedule Meeting</a>
            <a class="link-envelope" @click="$refs.messageModal.show()">Send Message</a>
        </div>

        <MessageToManagerModal
            ref="messageModal"
            title="Message Account Manager"
            body="Use your analyst hours to find the right startups for projects. Send us a message detailing what you’re looking for and how we can help."
        />
    </div>
</template>

<script>
import MessageToManagerModal from "@/components/MessageToManagerModal.vue";

export default {
    name: "ManagerBlock",
    components: {MessageToManagerModal},
    methods: {
        scheduleMeeting() {
            window.dataLayer.push(
                {
                    "event":"schedule meeting clicked"
                }
            );
        },
    }
}
</script>

<style scoped>

</style>
